import { cn } from "@punchup/utils/cn";

export default function ShortHeadline({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <h3 className={cn("font-anton uppercase", className)}>{children}</h3>;
}
